module.exports = __webpack_public_path__ + "img/customers.74f9e869.svg";